import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { useNavigate } from 'react-router-dom';
export function ModifyProfile() {
  const navigate = useNavigate();
  const enrolledCourses = [{
    name: 'Ethics & The Rules (with NAR Code of Ethics)',
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/23/2012'
  }, {
    name: "Don't Lose Your License",
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/11/2012'
  }, {
    name: 'The Owner Is In Default',
    status: '(Course enrolled)',
    creditType: '3 hrs. Legal Issues',
    created: '04/11/2012'
  }, {
    name: 'They Are A Protected Class',
    status: '(Course enrolled)',
    creditType: '3 hrs. Fair Housing',
    created: '04/11/2012'
  }, {
    name: 'A Letter From ADRE',
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/11/2012'
  }, {
    name: 'Are They Represented?',
    status: '(Section in progress)',
    creditType: '3 hrs. Agency Law',
    created: '04/11/2012'
  }, {
    name: 'Follow All The Laws',
    status: '(Course enrolled)',
    creditType: '3 hrs. Legal Issues',
    created: '04/11/2012'
  }, {
    name: 'No Secrets',
    status: '(Course enrolled)',
    creditType: '3 hrs. Disclosure',
    created: '04/11/2012'
  }, {
    name: 'Common Contract Issues',
    status: '(Section in progress)',
    creditType: '3 hrs. Contract Law',
    created: '04/11/2012'
  }];
  return <div className="space-y-6" data-id="element-1245">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1246">Manage Profile</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1247">
        {/* Left Column: Profile Fields */}
        <Card data-id="element-1248">
          <CardHeader data-id="element-1249">
            <CardTitle data-id="element-1250">Profile Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4" data-id="element-1251">
            <Input label="Title" defaultValue="Mr" data-id="element-1252" />
            <Input label="First Name" defaultValue="Admin" data-id="element-1253" />
            <Input label="Last Name" defaultValue="Admin" data-id="element-1254" />
            <Input label="Company" defaultValue="Desert Sage Seminars" data-id="element-1255" />
            <Input label="Address 1" defaultValue="15560 N. Frank Lloyd W" data-id="element-1256" />
            <Input label="Address 2" defaultValue="#B4-5185" data-id="element-1257" />
            <Input label="City" defaultValue="Scottsdale" data-id="element-1258" />
            <Select label="State/Province *" defaultValue="AZ" options={[{
            value: 'AZ',
            label: 'Arizona'
          }, {
            value: 'CA',
            label: 'California'
          }, {
            value: 'NV',
            label: 'Nevada'
          }]} data-id="element-1259" />
            <Input label="Zip" defaultValue="85260" data-id="element-1260" />
            <Input label="Phone" defaultValue="602-377-6207" data-id="element-1261" />
            <Input label="Email" helperText="Leave blank to keep existing email (administration@desertsageseminars.com)" data-id="element-1262" />
            <Input label="Fax" data-id="element-1263" />
            <Input label="How Did You Hear About Us" data-id="element-1264" />
            <Input label="Facebook" data-id="element-1265" />
            <Input label="Username" helperText="Leave blank to keep existing username (admin)" data-id="element-1266" />
            <Input type="password" label="Password" helperText="Leave blank to keep existing password" data-id="element-1267" />

            <div className="py-2" data-id="element-1268">
              <a href="#" className="text-blue-600 hover:underline text-sm" data-id="element-1269">
                Click here to obtain your license expiration date from ADRE
              </a>
            </div>

            <Input label="Available Courses" defaultValue="0" data-id="element-1270" />

            <div className="pt-4" data-id="element-1271">
              <Button data-id="element-1272">Update</Button>
            </div>
          </CardContent>
        </Card>

        {/* Right Column: Course Assignments */}
        <div className="space-y-6" data-id="element-1273">
          <Card data-id="element-1274">
            <CardContent className="space-y-4 pt-6" data-id="element-1275">
              <Select label="Course" options={[{
              value: '1',
              label: 'NAR Code of Ethics (NO CE CREDIT)'
            }, {
              value: '2',
              label: 'Ethics & The Rules (with NAR Code of Ethics)'
            }, {
              value: '3',
              label: 'Deeds, Fires & Water: Be Prepared'
            }, {
              value: '4',
              label: 'Are They Represented?'
            }, {
              value: '5',
              label: 'Mastering Agency Agreements'
            }, {
              value: '6',
              label: 'A Letter From ADRE'
            }, {
              value: '7',
              label: "Don't Lose Your License"
            }, {
              value: '8',
              label: 'BMC #1 AZ Residential-Statutes and Rules'
            }, {
              value: '9',
              label: 'BMC #2 AZ Residential-Broker Policies'
            }, {
              value: '10',
              label: 'BMC #3 AZ Residential-Broker Supervision'
            }, {
              value: '11',
              label: 'BMC #3B Property Management'
            }, {
              value: '12',
              label: 'What Goes Wrong In Contracts'
            }, {
              value: '13',
              label: 'Avoid The Oops: Contract Smarts for Agents'
            }, {
              value: '14',
              label: 'No Secrets'
            }, {
              value: '15',
              label: 'The Bottom Line of Disclosure'
            }, {
              value: '16',
              label: 'Your Clients Are Not Mushrooms'
            }, {
              value: '17',
              label: 'They Are A Protected Class'
            }, {
              value: '18',
              label: "Fair Housing In Today's World"
            }, {
              value: '19',
              label: 'Accidental Property Management'
            }, {
              value: '20',
              label: 'Follow All The Laws'
            }]} data-id="element-1276" />
              <Select label="Statuses" defaultValue="enrolled" options={[{
              value: 'completed',
              label: 'Course Completed'
            }, {
              value: 'in_progress',
              label: 'Course in Progress'
            }, {
              value: 'emailed',
              label: 'Certificate Emailed'
            }, {
              value: 'enrolled',
              label: 'Course Enrolled'
            }, {
              value: 'section_progress',
              label: 'Section in Progress'
            }]} data-id="element-1277" />
              <Button className="w-full gap-2" data-id="element-1278">
                <Plus className="h-4 w-4" data-id="element-1279" />
                Add
              </Button>
            </CardContent>
          </Card>

          <Card data-id="element-1280">
            <CardHeader data-id="element-1281">
              <CardTitle data-id="element-1282">Enrolled Courses</CardTitle>
            </CardHeader>
            <div className="overflow-x-auto" data-id="element-1283">
              <table className="w-full text-sm text-left" data-id="element-1284">
                <thead className="bg-slate-800 text-white font-medium border-b border-slate-700" data-id="element-1285">
                  <tr data-id="element-1286">
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-1287">
                      Course Name
                    </th>
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-1288">
                      Credit Type
                    </th>
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-1289">
                      Created
                    </th>
                    <th className="px-4 py-3" data-id="element-1290">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200" data-id="element-1291">
                  {enrolledCourses.map((course, index) => <tr key={index} className="hover:bg-slate-50" data-id="element-1292">
                      <td className="px-4 py-3 border-r border-slate-200" data-id="element-1293">
                        <div className="text-slate-900" data-id="element-1294">{course.name}</div>
                        <div className="text-slate-500 text-xs mt-0.5" data-id="element-1295">
                          {course.status}
                        </div>
                      </td>
                      <td className="px-4 py-3 border-r border-slate-200 text-slate-700" data-id="element-1296">
                        {course.creditType}
                      </td>
                      <td className="px-4 py-3 border-r border-slate-200 text-slate-700" data-id="element-1297">
                        {course.created}
                      </td>
                      <td className="px-4 py-3" data-id="element-1298">
                        <div className="flex items-center gap-2 text-sm" data-id="element-1299">
                          <button className="text-blue-600 hover:underline" onClick={() => navigate(`/profile/course-status/edit/${index}`)} data-id="element-1300">
                            Edit
                          </button>
                          <span className="text-slate-300" data-id="element-1301">|</span>
                          <button className="text-red-600 hover:underline" data-id="element-1302">
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}